if (!customElements.get('cross-sell')) {
  class CrossSell extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initialize();
    }

    initialize() {
      this.productId = this.dataset.crossSellId;
      this.ratio = this.dataset.crossSellRatio
        ? Number(this.dataset.crossSellRatio.replace(',', '.'))
        : 1;

      console.log('this.ratio', this.ratio);
      this.minimumQuantity = this.dataset.crossSellMinimumQuantity
        ? parseInt(this.dataset.crossSellMinimumQuantity)
        : 1;
      this.minimumQuantityPrice = this.dataset.crossSellMinimumQuantityPrice
        ? parseInt(this.dataset.crossSellMinimumQuantityPrice)
        : 0;
      this.tieredPrices = this.getTieredPrices(
        this.dataset.crossSellTieredPrices,
        this.minimumQuantity,
        this.minimumQuantityPrice
      );

      this.selectButton = this.querySelector('[data-select-button]');
      this.quantityElement = this.querySelector('[data-cross-sell-quantity]');
      this.priceElement = this.querySelector('[data-cross-sell-price]');
      this.mainAddButtonText = document.querySelector(
        '[data-main-product] product-form [name="add"] span'
      );

      if (!this.productId || !this.selectButton) {
        return;
      }

      // Initialize global cross-sell items array if it doesn't exist
      if (!window.crossSellItems) {
        window.crossSellItems = [];
      }

      this.selectButton.addEventListener('click', (event) => this.toggleSelected(event));
      this.updateQuantityAndPrice();
    }

    getTieredPrices(dataSet, minimumQuantity = 1, minimumQuantityPrice = 0) {
      const tieredPrices = dataSet && dataSet != 'null' ? JSON.parse(dataSet) : [];

      if (!tieredPrices.length || minimumQuantity < tieredPrices[0][0]) {
        tieredPrices.push([minimumQuantity, minimumQuantityPrice]);
      }

      tieredPrices.sort((a, b) => a[0] - b[0]);
      return tieredPrices;
    }

    updateQuantityAndPrice() {
      const mainQuantityInput = document.querySelector(
        'quantity-calculator input[name="quantity"]'
      );
      if (!mainQuantityInput) return;

      const mainQuantity = mainQuantityInput.valueAsNumber || 1;
      const crossSellQuantity = Math.ceil(mainQuantity * this.ratio);

      // Update quantity display
      if (this.quantityElement) {
        this.quantityElement.textContent = crossSellQuantity;
        this.dataset.crossSellQuantity = crossSellQuantity;
      }

      // Calculate and update price
      const price = this.calculatePrice(crossSellQuantity);
      if (this.priceElement && price) {
        this.priceElement.textContent = price;
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
      }

      // Handle minimum quantity styling
      if (crossSellQuantity < this.minimumQuantity) {
        this.classList.add('less-than-min');
      } else {
        this.classList.remove('less-than-min');
      }

      // Update global cross-sell items if this item is selected
      if (this.dataset.selected === 'true') {
        this.updateGlobalCrossSellItems(crossSellQuantity);
      }
    }

    calculatePrice(quantity) {
      if (!this.tieredPrices.length) return null;

      const tier = this.tieredPrices.findLast((tier) => quantity >= tier[0]);
      if (!tier) return null;

      const totalPrice = quantity * tier[1];
      const formattedPrice = (totalPrice / 100).toFixed(2).replace('.', ',');
      return formattedPrice;
    }

    toggleSelected(event) {
      if (event) {
        event.preventDefault();
      }

      const crossSellQuantity = parseInt(this.dataset.crossSellQuantity) || 1;
      const item = {
        id: this.productId,
        quantity: crossSellQuantity,
      };

      if (this.dataset.selected === 'true') {
        this.dataset.selected = 'false';
        window.crossSellItems = window.crossSellItems.filter(
          (existingItem) => existingItem.id !== item.id
        );
      } else {
        this.dataset.selected = 'true';
        window.crossSellItems = [
          ...window.crossSellItems.filter((existingItem) => existingItem.id !== item.id),
          item,
        ];
      }

      this.updateAddButtonText();
    }

    updateGlobalCrossSellItems(quantity) {
      const itemIndex = window.crossSellItems.findIndex((item) => item.id === this.productId);
      if (itemIndex !== -1) {
        window.crossSellItems[itemIndex].quantity = quantity;
      }
    }

    updateAddButtonText() {
      if (!this.mainAddButtonText || !window.crossSellStrings) return;

      if (window.crossSellItems.length > 0) {
        this.mainAddButtonText.textContent = window.crossSellStrings.addAllToCart;
      } else {
        this.mainAddButtonText.textContent = window.crossSellStrings.addToCart;
      }
    }
  }

  customElements.define('cross-sell', CrossSell);
}
